import { render, staticRenderFns } from "./chatroomComment.vue?vue&type=template&id=03c8d513&"
import script from "./chatroomComment.vue?vue&type=script&lang=js&"
export * from "./chatroomComment.vue?vue&type=script&lang=js&"
import style0 from "./chatroomComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports